import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SelfCareFamilyMemberDiscountPackageBlockData from 'Models/Content/SelfCareFamilyMemberDiscountPackageBlockData';
import SelfCareFamilyMemberDiscountPackageMain from './SelfCareFamilyMemberDiscountPackageMain';

export default class AbroadCustomerUsageGraphsBlock extends EpiComponent<SelfCareFamilyMemberDiscountPackageBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <SelfCareFamilyMemberDiscountPackageMain iContent={this.props.data} context={this.getContext()} />;
  }
}

